module.exports = __webpack_public_path__ + "static/media/yuan2.171ac7e4.png";